import { render, staticRenderFns } from "./PlanoContasForm.vue?vue&type=template&id=d99f8b90&scoped=true"
import script from "./PlanoContasForm.vue?vue&type=script&lang=js"
export * from "./PlanoContasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99f8b90",
  null
  
)

export default component.exports